import type { IncidentListRow } from '@ngsos/portal-core/incidents';
import type { Incident, PortalCall } from '@/signalr/contracts';
import type { IncidentListContext } from './incidentListContext';
import { IncidentListMap } from '@/features/shared/map/IncidentListMap';
import { CallNotificationsMap } from './map/CallNotificationsMap';

export type IncidentListMapContentProps = {
  context: IncidentListContext;
  incidents?: readonly IncidentListRow[];
  sourceIncidents: readonly Incident[];
  callNotifications: readonly PortalCall[];
};

export function IncidentListMapContent({
  context,
  incidents,
  sourceIncidents,
  callNotifications,
}: IncidentListMapContentProps) {
  if (context === 'incidents') {
    return <IncidentListMap incidents={incidents} disableControls />;
  }

  if (context === 'callNotifications') {
    return <CallNotificationsMap callNotifications={callNotifications} incidents={sourceIncidents} disableControls />;
  }

  return null;
}
